<style scoped lang="scss">
.effect-lists2 li .eff_img {
  width: fit-content;
  margin-left: auto;
  padding-top: 30px;
  margin-right: auto;
}
  .strengths{
    display: flex;
    margin-top: 30px;
    li{
      flex:1;
      text-align: center;
      border-right: 1px solid #eee;
      padding:0 40px;
      &:last-child{
        border: 0;
      }
      h4{
        font-size: 18px;
        margin-bottom: 10px;
        color:#014492;
      }
    }
  }
  .service_chan{
    margin-bottom: 20px;
    display: flex;
    overflow: auto;
    justify-content: space-around;
    li{
      width: 190px;
      height: 188px;
      //margin-right:100px;
      background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
      background-size: auto!important;
      .img{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        padding-top: 20px;
        padding-bottom: 20px;
      }
      p{
        font-size: 16px;
        color:#4e4e4e;
        margin-bottom: 10px;
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
      }
      .liaojie{
        width: -moz-fit-content;
        width: fit-content;
        margin-left: auto;
        margin-right: auto;
        color:#959595;
        cursor: pointer;
      }
    }
    li:hover{
      background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
      background-size: auto!important;
      p{
        color: #fff;
      }
      .liaojie{
        color: #fff;
      }
    }
    li:last-child{
      margin-right: 0;
    }
  }
  .download{
    display: flex;
    flex-wrap: wrap;
    border-left: 1px solid #E4E6EA;
    li{
      width:50%;
      padding:20px 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E4E6EA;
      border-right: 1px solid #E4E6EA;
      font-size: 16px;
      cursor: pointer;
      &:nth-of-type(1){
        border-top: 1px solid #E4E6EA;
      }
      &:nth-of-type(2){
        border-top: 1px solid #E4E6EA;
      }
      &:hover{
        color:#014492;
      }
    }
    .btn-primary{
      font-size: 14px;
      span{
        margin-right: 7px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
      }
    }
  }
  .c-title small{
    margin-top: 10px;
  }
  .required{
    background: none!important;
    margin-left: 0!important;
  }
  .desc{
    font-size: 16px;
  }
  .effect-lists{
    //display: block!important;
    justify-content: space-between;
    flex-wrap:wrap;
    overflow: auto;
  }
  .cons{
    display: none;
  }
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .cons{
    display: block!important;
  }
  .effect-lists{
    justify-content: flex-start!important;
  }
  .con{
    display: none!important;
  }
  .container100{
    margin-bottom: 20px!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/基因调控/banner.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/一级标题Banner/基因调控.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
      <p class="desc">基因表达调控是生物体内基因进行表达、调节，使细胞中的基因表达在时间、空间上处于有序状态，并对环境条件的变化作出反应的复杂过程。基因表达调控可在多个水平上进行，包括基因水平、转录水平、转录后水平、翻译水平和翻译后水平的调控，是个体生命细胞分化、形态发生和生长发育的基础。</p>
        <div class="gene_img con" style="margin-top: 20px;margin-bottom: 20px; text-align: center;margin-left: auto;margin-right: auto;width: -moz-fit-content;width: fit-content; "><img src="@/assets/img/产品及服务/基因调控/ct.png" ></div>
        <div class="gene_img cons" style="margin-top: 20px;margin-bottom: 20px; text-align: center;margin-left: auto;margin-right: auto;width: -moz-fit-content;width: fit-content; "><img src="@/assets/img/产品及服务/基因调控/ct_2.png" ></div>
        <p class="desc" style="margin-bottom: 10px;">基因编辑工具的迅速发展使得在天然染色质环境中有针对性地进行表观基因组编辑和转录调控成为可能，特别是CRISPR/Cas9技术的发展。CRIPSR-dCas9系统提供了一个研究转录调控和进行表观基因组编辑的平台，其设计原理在于把各种表观调控效应器融合到dCas9上，通过核酸酶的靶向并结合目标DNA的特性实现特定基因组位点上表观基因组的编辑。</p>
        <p class="desc" style="margin-bottom: 10px;">基因的表达调控进一步影响着生物的表观遗传，DNA甲基化修饰是基因表达调控的重要方式，是表观遗传研究中重要的领域。在分化、发育、基因印迹、X 染色体失活与维持组织特异性等众多方面起着重要作用。同时在许多复杂疾病，如肿瘤癌症、神经系统紊乱、糖尿病等的发生发展也与DNA甲基化有着千丝万缕的关系。</p>
        <p class="desc" style="margin-bottom: 10px;">随着精准医疗的发展，遗传风险预测以及肿瘤代谢通路研究等检测技术已经得到广泛应用，大多数遗传病和复杂疾病都和基因突变有很大的联系，基因 Pannel 检测和SNP 突变分析是目前临床研究的肿瘤标志物和用药分型的一大热门。</p>
        <p class="desc">擎科生物凭借完善的研发设备平台和自有的合成产业链优势，可提供基因功能系列服务：CRISPR/Cas9 基因编辑系列服务，基因干扰，基因过表达研究，甲基化检测，蛋白表达服务，个性化基因 Pannel 检测以及SNP 突变分析等，为基因功能研究提供优质解决方案。</p>
      </div>
        <div class="container">
          <div class="c-title">服务类型<small>Service type</small></div>
          <div class="container con">
            <ul class="effect-lists1 effect-lists">
              <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
                <img :src="`/static/img/tk_${item.img}${currentService===index ? '' : ''}.png`">
                <p style="margin-top: 10px;">{{item.name}}</p>
              </li>
            </ul>
          </div>
          <div class="cons" style="margin-top: 20px;">
            <ul class="effect-lists1 effect-lists">
              <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
                <img :src="`/static/img/tk_${item.img}${currentService===index ? '' : ''}.png`" style="width: 60px;">
                <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="c-title">资源中心<small>Resource center</small></div>
        <div class="container mt30 mb30">
          <ul class="download">
            <li v-for="item in resourcesLists" :key="item.id">
              {{item.name}}
              <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
              <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            </li>
          </ul>
        </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/tk1_${item.img}${currentType===index ? '' : '_active'}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists service_chan">
            <li v-for="(item, index) in gene1" :key="index" class="pointer"   @click="$router.push(item.ref)">
              <div class="eff_img"><img :src="`/static/img/tk1_${item.img}${currentType===index ? '' : '_active'}.png`" style="width: 55px!important;height: 55px;"></div>
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
              <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: '基因编辑', img: '1', ref: '/products/Gene_editing'},
        {name: '基因干扰', img: '2', ref: '/products/Gene_interference'},
        {name: '蛋白表达', img: '3', ref: '/products/Protein_expression'},
        // {name: '甲基化检测', img: '4', ref: '/products/Methylation_detection'},
        {name: '基因过表达', img: '5', ref: ''},
        // {name: '基因检测panel定制及SNP分型', img: '6', ref: '/products/Gene_SNP'},
        ],
      gene1: [
        {name: '基因合成',img: '1', ref: '/tec/gen_compose'},
        {name: '引物合成', img: '2',ref: '/tec/compose1'},
        {name: '基因检测',img: '3', ref: '/products/Gene'},
        {name: '病毒包装',img: '4', ref: '/Virus/Virus_packaging'},
        {name: '常规分子项目' ,img: '5',ref: '/products/Conventional_molecular_project'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Gene_regulation.vue